import React from "react";
import DashboardLayout from "../../utils/DashboardLayout";
import MessageLists from "../../components/Message/MessageLists";


const MessageList = () => {

  return (
    <DashboardLayout>
     <MessageLists />
    </DashboardLayout>
  );
};

export default MessageList;
